import { Space } from 'antd';
import Divider from 'antd/lib/divider';
import React from 'react';

import { AccountRegisterModal } from './registerAccount/AccountRegisterModal';
import styles from './styles/BusinessAccountsManagement.module.less';

export const BusinessAccountsManagementMenu = () => {
	return (
		<>
			<Divider />
			<div className={styles.menu}>
				<Space direction="horizontal">
					<AccountRegisterModal />
				</Space>
			</div>
			<Divider />
		</>
	);
};
